const headerSteps = [
  {
    target: 'body',
    content: 'Willkommen! Lassen Sie uns einen kurzen Rundgang durch die Hauptkopfzeile und Navigation machen.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tut="header-logo"]',
    content: 'Dies ist das Hauptlogo. Sie können es jederzeit anklicken, um zur Startseite zurückzukehren.',
  },
  {
    target: '[data-tut="header-nav-links"]',
    content: 'Dies sind Ihre Hauptnavigationslinks, die Ihnen Zugriff auf den Chatbot, das Dashboard und die Anomalie-Erkennungs-Tools geben.',
  },
  {
    target: '[data-tut="header-contact-btn"]',
    content: 'Verwenden Sie diese Schaltfläche, wenn Sie den Support kontaktieren müssen.',
  },
  {
    target: '[data-tut="profile-user-box"]',
    content: 'Dies ist Ihr Benutzerprofil-Menü. **Klicken Sie jetzt darauf**, um das Menü zu öffnen und weitere Optionen zu sehen.',
    spotlightClicks: true,
    hideFooter: true,
  },
  {
    target: '[data-tut="profile-theme-toggle"]',
    content: 'Großartig! Im Menü können Sie hier zwischen hellem und dunklem Modus wechseln.',
  },
  {
    target: '[data-tut="profile-edit"]',
    content: 'Klicken Sie hier, um zu Ihrer Profilseite zu gelangen und Ihre persönlichen Daten oder Ihren Avatar zu aktualisieren.',
  },
  {
    target: '[data-tut="profile-user-guide"]',
    content: 'Und schließlich können Sie diese Schaltfläche jederzeit anklicken, um diese Anleitung erneut zu starten!',
  },
  {
    target: '[data-tut="profile-clear-cache"]',
    content: 'Diese Schaltfläche löscht den Cache der verarbeiteten Dateien auf dem Server. Verwenden Sie dies, wenn Ihre Cloud-Dateien nicht korrekt synchronisiert werden.',
  },
  {
    target: '[data-tut="profile-logout"]',
    content: 'Klicken Sie hier, um sich von Ihrem Konto abzumelden.',
  },
];

const dashboardSteps = [
  {
    target: '[data-tut="dashboard-sidebar-toggle"]',
    content: 'Willkommen! Sie können diese Schaltfläche verwenden, um die Seitenleiste ein- oder auszublenden.',
    disableBeacon: true,
  },
  {
    target: '[data-tut="dashboard-source-list"]',
    content: 'Hier werden Ihre verfügbaren Berichtsquellen angezeigt. Für neue Benutzer zeigen wir ein Beispiel an.',
  },
  {
    target: '[data-tut="dashboard-settings-panel"]',
    content: 'In diesem Bereich können Sie Ihre Cloud-Speichereinstellungen verwalten.',
  },
  {
    target: '[data-tut="dashboard-source-history"]',
    content: 'Klicken Sie auf das Symbol **Verlauf**, um frühere Versionen dieses Berichts anzuzeigen und herunterzuladen.',
  },
  {
    target: '[data-tut="dashboard-source-rename"]',
    content: 'Klicken Sie auf das Symbol **Bearbeiten**, um die Berichtsquelle umzubenennen.',
  },
  {
    target: '[data-tut="dashboard-source-delete"]',
    content: 'Klicken Sie auf das Symbol **Löschen**, um die Berichtsquelle dauerhaft zu entfernen.',
  },
  {
    target: '[data-tut="dashboard-source-item"]',
    content: 'Klicken Sie nun **auf diese Berichtsquelle**, um sie auszuwählen und ihre Daten anzuzeigen. Es gibt keine "Weiter"-Schaltfläche – diese Aktion ist erforderlich.',
    hideFooter: true,
    spotlightClicks: true,
  },
  {
    target: '[data-tut="dashboard-report-viewer"]',
    content: 'Großartig! Die Daten für Ihren ausgewählten Bericht werden in diesem Hauptbereich angezeigt.',
  },
  {
    target: '[data-tut="dashboard-tab-daily"]',
    content: 'Dies ist die Registerkarte **Täglicher Bericht**. Die Tabelle unten zeigt Ihre Daten Tag für Tag an, ähnlich wie in einer Excel-Tabelle.',
  },
  {
    target: '[data-tut="dashboard-tab-monthly"]',
    content: 'Klicken Sie auf diese Registerkarte, um einen **Monatlichen Bericht** anzuzeigen, der Ihre Daten nach Monaten zusammenfasst.',
  },
  {
    target: '[data-tut="dashboard-tab-overview"]',
    content: 'Klicken Sie auf die Registerkarte **Übersicht**, um interaktive Diagramme, Statistiken und Datumsfilter für Ihre Berichtsdaten anzuzeigen.',
  },
  {
    target: '[data-tut="dashboard-daily-table"]',
    content: 'Diese Tabelle zeigt die täglichen Daten. (Bei neuen Benutzern werden hier Beispieldaten angezeigt).',
  },
  {
    target: '[data-tut="dashboard-download-button"]',
    content: 'Mit dieser Schaltfläche können Sie jederzeit den vollständigen, ursprünglichen Excel-Bericht für die ausgewählte Quelle herunterladen.',
  },
];

const anomalySteps = [
  {
    target: '[data-tut="anomaly-controls"]',
    content: 'Willkommen auf der Seite zur Anomalie-Erkennung! Dies ist Ihre Hauptsteuerleiste.',
    disableBeacon: true,
  },
  {
    target: '[data-tut="anomaly-import-button"]',
    content: 'Klicken Sie hier, um Ihre Datendateien (.csv, .xlsx, .zip usw.) von Ihrem Computer zu importieren.',
  },
  {
    target: '[data-tut="anomaly-sync-button"]',
    content: 'Wenn Sie Cloud-Speicher eingerichtet haben, klicken Sie hier, um Ihre Dateien zu synchronisieren.',
  },
  {
    target: '[data-tut="anomaly-file-list"]',
    content: 'Alle Ihre importierten Dateien werden in diesem Bereich aufgelistet. (Hier wird ein Beispiel für diese Anleitung angezeigt). Klicken Sie auf eine beliebige Datei, um sie für die Analyse "aktiv" zu schalten.',
  },
  {
    target: '[data-tut="anomaly-file-search"]',
    content: 'Sie können hier Ihre Dateiliste durchsuchen oder filtern.',
  },
  {
    target: '[data-tut="anomaly-file-item"]',
    content: 'Dies ist ein einzelner Dateieintrag. Klicken Sie darauf, um ihn auszuwählen. Sie können ihn auch mit der Schaltfläche "x" löschen.',
    hideFooter: true,
    spotlightClicks: true,
  },
  {
    target: '[data-tut="anomaly-means-button"]',
    content: 'Nachdem Sie eine Datei ausgewählt haben, können Sie dies verwenden, um die Mittelwerte für deren Sensoren zu berechnen.',
  },
  {
    target: '[data-tut="anomaly-analyze-button"]',
    content: 'Dies ist die Hauptanalyse-Schaltfläche. Klicken Sie darauf, um Schwellenwerte zu konfigurieren und eine Analyse durchzuführen. (Diese Aktion ist erforderlich, um fortzufahren.)',
    hideFooter: true,
    spotlightClicks: true,
  },
  {
    target: '[data-tut="threshold-modal"]',
    content: 'Dies ist das Konfigurations- & Analyse-Fenster. Hier legen Sie die Parameter für die Anomalie-Erkennung fest.',
    spotlightClicks: true,
  },
  {
    target: '[data-tut="threshold-tab-pct"]',
    content: 'Sie können zwischen zwei Analysetypen wählen. Dies ist "Prozentsatz", der nach Abweichungen von einem gleitenden Durchschnitt sucht.',
  },
  {
    target: '[data-tut="threshold-tab-lowhigh"]',
    content: 'Oder Sie können auf "Niedrig / Hoch" klicken, um feste Mindest- und Höchstwerte für jeden Sensor festzulegen.',
  },
  {
    target: '[data-tut="threshold-table"]',
    content: '(Wenn Sie ein neuer Benutzer sind, zeigen wir Beispieldaten an). Diese Tabelle listet alle verfügbaren Sensoren auf. Sie können für jeden einen spezifischen Schwellenwert festlegen.',
  },
  {
    target: '[data-tut="threshold-save"]',
    content: 'Wenn Sie fertig sind, klicken Sie auf "Speichern und Analysieren", um die Erkennung auszuführen. Für diese Anleitung schließen wir das Fenster einfach.',
  },
  {
    target: '[data-tut="threshold-reset"]',
    content: 'Sie können hier auch alle Werte auf ihre Standardwerte zurücksetzen.',
  },
  {
    target: '[data-tut="threshold-close"]',
    content: 'Klicken Sie auf die Schaltfläche "Schließen" (X), um zur Hauptseite zurückzukehren. (Diese Aktion ist erforderlich, um fortzufahren.)',
    hideFooter: true,
    spotlightClicks: true,
  },
  {
    target: '[data-tut="anomaly-analyze-sensors-button"]',
    content: 'Großartig! Diese Schaltfläche "Sensoren analysieren" öffnet ein Fenster für eine detaillierte Betrachtung einzelner Sensordiagramme. Klicken Sie darauf, um fortzufahren.',
    hideFooter: true,
    spotlightClicks: true,
  },
  {
    target: '[data-tut="analysis-modal"]',   
    content: 'Dies ist das Sensoranalyse-Fenster, in dem Sie Sensordaten interaktiv erkunden können.',
    spotlightClicks: true,
  },
  {
    target: '[data-tut="analysis-sensor-list"]',
    content: '(Zeigt Beispieldaten). Dieser Bereich listet alle verfügbaren Sensoren auf. Sie können Sensoren an-/abwählen, um sie dem Diagramm hinzuzufügen oder zu entfernen.',
  },
  {
    target: '[data-tut="analysis-plot"]',
    content: 'Das Hauptdiagramm erscheint hier. Sie können zoomen und schwenken, um die Daten zu erkunden.',
  },
  {
    target: '[data-tut="analysis-toolbar"]',
    content: 'Verwenden Sie diese Symbolleiste, um durch Ihren Diagrammverlauf zu navigieren (zurück, vorwärts) oder die Ansicht zurückzusetzen (Home).',
  },
  {
    target: '[data-tut="analysis-mode-toggle"]',
    content: 'Wechseln Sie Ihren Mausinteraktionsmodus zwischen "Zoomen" (klicken und ziehen, um einen Bereich auszuwählen) und "Verschieben" (klicken und ziehen, um das Diagramm zu bewegen).',
    placement: 'bottom',
    spotlightPadding: 8,
  },
  {
    target: '[data-tut="analysis-y2-limit"]',
    content: 'Für Sensoren auf der sekundären Y-Achse (wie "IW22") können Sie hier deren Achsenlimit für eine bessere Sichtbarkeit anpassen.',
  },
  {
    target: '[data-tut="analysis-legend"]',
    content: 'Die Diagrammlegende erscheint hier und zeigt Ihnen die Farbe und den Namen für jeden aktiven Sensor.',
  },
  {
    target: '[data-tut="analysis-close"]',
    content: 'Klicken Sie auf die Schaltfläche "Schließen" (X), um zur Hauptseite zurückzukehren. (Diese Aktion ist erforderlich, um fortzufahren.)',
    hideFooter: true,
    spotlightClicks: true,
  },
  {
    target: '[data-tut="anomaly-pdf-button"]',
    content: 'Nachdem eine Analyse abgeschlossen ist, können Sie hier einen PDF-Bericht aller Anomalie-Diagramme herunterladen.',
  },
  {
    target: '[data-tut="anomaly-excel-button"]',
    content: 'Diese Schaltfläche generiert einen vollständigen Excel-Bericht für Ihre Dateien und speichert ihn in Ihrem Dashboard.',
  },
  {
    target: '[data-tut="anomaly-plot-labelframe"]',
    content: 'Wenn eine Analyse abgeschlossen ist, erscheinen alle erkannten Anomalie-Diagramme in diesem Hauptbereich.',
  },
  {
    target: '[data-tut="anomaly-plot-controls"]',
    content: 'Sie können diese Schaltflächen verwenden, um Anomalien "Alle auswählen" oder die "Auswahl aufheben".',
  },
  {
    target: 'body',
    content: "Das war's! Sie haben den Rundgang für die Anomalie-Erkennungs-Seite abgeschlossen.",
    placement: 'center',
  },
];

export const allTutorialSteps = {
  header: headerSteps,
  dashboard: dashboardSteps,
  anomaly: anomalySteps,
};